// extracted by mini-css-extract-plugin
export default {"centerVideo":"VideoFull_centerVideo__yniYE","videoDesc":"VideoFull_videoDesc__iltjU","imageHeight":"VideoFull_imageHeight__TPOOe"};